import {
  PricingPlan,
  V3PricingPlan,
  v3PricingPlans,
  V4PricingPlan,
  V4PricingPlanOrEnterprise,
  v4PricingPlans,
} from '@neptune/shared/core-organizations-domain';

export const isV3Pricing = (pricingPlan: PricingPlan | undefined): pricingPlan is V3PricingPlan => {
  return pricingPlan !== undefined && v3PricingPlans.includes(pricingPlan);
};

export const isV4Pricing = (pricingPlan: PricingPlan | undefined): pricingPlan is V4PricingPlan => {
  return pricingPlan !== undefined && v4PricingPlans.includes(pricingPlan);
};

export const isEnterprisePricing = (
  pricingPlan: PricingPlan | undefined,
): pricingPlan is 'enterprise' => {
  return pricingPlan === 'enterprise';
};

export function isV3OrV4Pricing(
  pricingPlan: PricingPlan | undefined,
): pricingPlan is V3PricingPlan | V4PricingPlan {
  return isV3Pricing(pricingPlan) || isV4Pricing(pricingPlan);
}

export const isV4OrEnterprisePricing = (
  pricingPlan: PricingPlan | undefined,
): pricingPlan is V4PricingPlanOrEnterprise => {
  return isV4Pricing(pricingPlan) || isEnterprisePricing(pricingPlan);
};
